import styled, { StyledProps } from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { mathVars, sm } from '@ucheba/utils/helpers/styles/mixins'
import {
  EModSpacingH,
  EModSpacingV,
  IModSpacingH,
  IModSpacingV,
} from '@ucheba/utils/helpers/styles/mod.types'

const Block = styled.table<StyledProps<IModSpacingV & IModSpacingH>>`
  width: 100%;

  ${Object.keys(EModSpacingV).map(
    (item) => sm.mod(EModSpacingV[item])`
      tbody td {
        padding-top: ${sv.spacing[item]};
        padding-bottom: ${sv.spacing[item]};
      }
    `
  )};

  ${Object.keys(EModSpacingH).map(
    (item) => sm.mod(EModSpacingH[item])`
     tbody td {
        padding-left: ${mathVars(sv.spacing[item], '/', '2')};
        padding-right: ${mathVars(sv.spacing[item], '/', '2')};
      }
    `
  )};
`

export default { Block }
